/* SIGN COLOUR -- the ONE rule for "green when positive, red when negative" (W-003 C, 2026-09-24).
 *
 * The two values are the colours the Scenarios comparison table's delta column already used
 * (and KPIDashboardPage's C_GREEN / C_RED) -- extracted, not new. A value that is exactly zero
 * (or not a number) returns the caller's own default, so a zero keeps the surface's normal
 * text colour: every page renders zero as "--" and colouring a dash would say nothing.
 */
export const SIGN_POSITIVE = "#059669";
export const SIGN_NEGATIVE = "#DC2626";

export function signColor(v, zeroColor) {
  return v > 0 ? SIGN_POSITIVE : v < 0 ? SIGN_NEGATIVE : zeroColor;
}
